export const vastUrls: string[] = [
  'ad.adriver.ru/cgi-bin/rle.cgi',
  'wcm-ru.',
  'bs.serving-sys.ru',
  'eye.targetads.io',
] as const;